import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { isSmallerSelector } from '~/components/layout/mediaquery.js';
import useTranslations from '~/components/translation/use-translations.ts';
import FloatingSupportButtonBase from './floating-support-button-base.js';

const TEXT_KEYS = ['MOBILE_MAIN_MENU_SUPPORT'];

const FloatingSupportButton = () => {
	const smaller = useSelector(isSmallerSelector);
	const { translations, isLoadingTranslations } = useTranslations(TEXT_KEYS);
	const location = useLocation();
	return (
		!isLoadingTranslations &&
		location.pathname === '/' && (
			<FloatingSupportButtonBase buttonClassName={smaller ? 'is-small' : 'is-large'}>
				{!smaller && <span className="support-text">{translations.MOBILE_MAIN_MENU_SUPPORT}</span>}
			</FloatingSupportButtonBase>
		)
	);
};

export default FloatingSupportButton;
